import { render, staticRenderFns } from "./AccountActivation.vue?vue&type=template&id=1d104d65&scoped=true"
import script from "./AccountActivation.vue?vue&type=script&lang=js"
export * from "./AccountActivation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d104d65",
  null
  
)

export default component.exports